import { t } from '../../lib/i18n';

/**
 * Özet kuralları — ana süreçteki karşılığıyla aynı tutulmalı
 * (src/services/summaryRules.ts).
 */

/** Bu süreden kısa kayıtlar yapay zekâya özetletilmez. */
export const MIN_SUMMARY_SECONDS = 60;

/**
 * Uygulamanın özet yerine yazdığı sistem mesajları. Kayıt anındaki dilde
 * saklanıyorlar; gösterilirken seçili dile çevriliyorlar (eski kayıtlar da).
 */
const SHORT_RECORDING = {
  tr: 'Bu kayıt özet çıkarmak için çok kısa (1 dakikanın altında). Ses kaydı ve transkript aşağıda duruyor.',
  en: 'This recording is too short to summarize (under 1 minute). The audio and transcript are below.',
};
const SUMMARY_FAILED = {
  tr: 'Bu kayıt canlı olarak transkript edildi; özet üretilemedi.',
  en: 'This recording was transcribed live, but a summary couldn’t be generated.',
};
const NO_SPEECH = {
  tr: 'Bu kayıtta konuşma algılanamadı, transkript boş kaldı.',
  en: 'No speech was detected in this recording, so the transcript is empty.',
};
/** Bot kayıtları için ana sürecin yazdığı karşılık. */
const NO_SPEECH_BOT = {
  tr: 'Bu toplantıda konuşma algılanamadı, transkript boş kaldı.',
  en: 'No speech was detected in this meeting, so the transcript is empty.',
};

const SYSTEM_MESSAGES = [SHORT_RECORDING, SUMMARY_FAILED, NO_SPEECH, NO_SPEECH_BOT];

export const shortRecordingMessage = () => t(SHORT_RECORDING.tr, SHORT_RECORDING.en);
export const summaryFailedMessage = () => t(SUMMARY_FAILED.tr, SUMMARY_FAILED.en);
export const noSpeechMessage = () => t(NO_SPEECH.tr, NO_SPEECH.en);

/** Kayıtlı bir sistem mesajını seçili dile çevirir; diğer metinlere dokunmaz. */
export function displaySummaryText(text: string): string {
  const match = SYSTEM_MESSAGES.find((message) => message.tr === text || message.en === text);
  return match ? t(match.tr, match.en) : text;
}

/** Kullanıcının vermediği, uygulamanın koyduğu varsayılan başlık mı (iki dilde de)? */
export function isGenericMeetingTitle(title: string | null | undefined): boolean {
  const value = title?.trim().toLocaleLowerCase('tr') ?? '';
  return (
    !value ||
    value === 'yeni kayıt' ||
    value === 'new recording' ||
    value.startsWith('bot kaydı') ||
    value.startsWith('bot recording') ||
    value.startsWith('kısa kayıt') ||
    value.startsWith('short recording')
  );
}
